import { queryOptions, useQuery } from "@tanstack/react-query";
import { fetchLang, useFetchLang } from "../helpers/language.helpers";
import { apiGet } from "../helpers/request.helpers";
import { useAuth } from "../AuthContext";

// language is read per call, not at module load: a language switch does not
// reload the page, and invalidations elsewhere key on the current language.
export const userProgressSummaryQueryOptions = ({
  userId,
  enabled,
  language = fetchLang(),
}: {
  userId: number;
  enabled?: boolean;
  language?: string;
}) => {
  return queryOptions<UserSummaryResponse, Error>({
    queryKey: ["user-progress-summary", userId, language],
    queryFn: async () =>
      await apiGet("/statistics/show-user-summary", {
        user_id: userId,
        language,
      }),
    enabled,
  });
};

export type UserSummaryResponse = {
  User: User;
  TotalRuntime: number;
  StylePointCount: number;
  LastRun: LastRun;
};

type LastRun = {
  PublicExerciseUUID: string;
  ExerciseName: string;
  ExerciseRunID: number;
};

type User = {
  SchoolClassName: string;
  SchoolClassID: number;
  ID: number;
  Name: string;
  OrganizationID: number;
  SchoolID: number;
};

export function useUserProgressSummary(user_id: number) {
  const { isAuthenticated } = useAuth();
  const language = useFetchLang();
  return useQuery(
    userProgressSummaryQueryOptions({
      userId: user_id,
      enabled: isAuthenticated,
      language,
    })
  );
}
